enum AdType {
  GRAY_LIST = 1,
  WHITE_LIST = 2,
  BLACK_LIST = 3
}

export default AdType
